import { render, staticRenderFns } from "./modalAmend.vue?vue&type=template&id=7326c635&scoped=true&"
import script from "./modalAmend.vue?vue&type=script&lang=js&"
export * from "./modalAmend.vue?vue&type=script&lang=js&"
import style0 from "./modalAmend.vue?vue&type=style&index=0&id=7326c635&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7326c635",
  null
  
)

export default component.exports